export const uploadingFieldNames = {
  house: 'house',
  accountType: 'accountType',
  importType: 'importType',
  file: 'file',
  sheet: 'sheet',
  dataStartRow: 'dataStartRow',
};
